const initialStateRole = {
  role: [],
  update_role: false,
};

export default initialStateRole;